import * as React from 'react'

import {useToast} from '@chakra-ui/react'

type Options = {
  onErrorToast?: string
  onSuccessToast?: string
}

const useLoadingState = (onSubmit: (e?: React.FormEvent) => Promise<void> | void, options?: Options) => {
  const toast = useToast()

  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<Error | null>(null)

  const handleSubmit = React.useCallback(
    async (e?: React.FormEvent) => {
      setLoading(true)
      try {
        await onSubmit(e)

        options?.onSuccessToast &&
          toast({
            isClosable: true,
            status: 'success',
            title: options.onSuccessToast,
          })
      } catch (e) {
        setError(e as Error)
        console.error(e as Error)
        options?.onErrorToast &&
          toast({
            isClosable: true,
            status: 'error',
            title: options.onErrorToast,
          })
      } finally {
        setLoading(false)
      }
    },
    [onSubmit, options, toast]
  )

  // TODO: return tuple to avoid name conflicts and cleanup places where old useLoadingState was used
  return {handleSubmit, loading, error}
}

export default useLoadingState
